import type { ReactNode } from "react";
import Field from "./Field";
import FieldList from "./FieldList";

type Props =
    | { label: string; value?: ReactNode | string; values?: never }
    | { label: string; values: string[]; value?: never };

function SectionRow({ label, value, values }: Props) {
    if (values !== undefined) {
        return <FieldList label={label} values={values} />;
    }
    return <Field label={label} value={value} />;
}

export default SectionRow;
